module.exports = __webpack_public_path__ + "static/img/manual-6.e2ba1cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-6.png
// module id = lmkv
// module chunks = 4